// store.ts
// store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from "./authSlice";
import filterReducer from "./filterSlice";
import languageReducer from "./language";
const rootReducer = combineReducers({
  auth: authReducer,
  filter: filterReducer,
  language: languageReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'language'],
  debug: true // Enable debug mode
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
